import { gatewayService } from "@/_services/gateway.service";

// /**
//  * Get files by company of Data Model
//  * @param {object} _this: context variables
//  * @param {object} queryParams: query parameters for the endpoint with id_company and isCurrency
//  */

export async function getFilesByCompany(_this, queryParams) {
  gatewayService.user
    .dataModelInfo({
      format: "json",
      selected_company: queryParams.idCompany,
      query_type: queryParams.isCurrency
    })
    .then(data => {
      parseData(data, queryParams.isCurrency);
      Object.assign(_this.data, { companyFiles: data });
      Object.assign(_this.loading, { allData: false });
    })
    .catch(function(error) {
      Object.assign(_this.data, { companyFiles: [] });
      Object.assign(_this.loading, { allData: false });
      console.error(error);
    });
}

function parseData(data, isCurrency) {
  data.forEach(d => {
    if (d.name.includes("exposure")) {
      d.auxName = "Exposures";
    } else if (d.name.includes("hedge")) {
      d.auxName = "Hedges";
    } else if (d.name.includes("commodityratio")) {
      d.auxName = "Ratios";
    } else if (d.name.includes("commodity") || d.name.includes("currency")) {
      d.auxName = "Exposures and Hedges in one file";
    }
  });

  // Add "Ratios" if not present
  if (isCurrency === "commodities" && !data.some(d => d.auxName === "Ratios")) {
    data.push({ auxName: "Ratios", name: "commodityratio", file_data: [] });
  }

  // Sort the data with auxName
  data.sort((a, b) => {
    const order = [
      "Exposures",
      "Hedges",
      "Ratios",
      "Exposures and Hedges in one file"
    ];
    return order.indexOf(a.auxName) - order.indexOf(b.auxName);
  });
}
